let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("9tZVl")]).then(() => parcelRequire('2rmzr'));